import * as Models from '../../../models';
import { buildParticipantInfoMapper } from '../../../mappers/api2_0';
import { ChampionshipsEndpoints } from '../../../endpoint';

export interface GetParticipantInfoProps {
  championshipId: Models.ChampionshipId;
  studentId: Models.StudentId;
}

export const getParticipantInfo = (params: GetParticipantInfoProps) =>
  ChampionshipsEndpoints.getParticipant(params).then(buildParticipantInfoMapper);
